import { render, staticRenderFns } from "./Strech.vue?vue&type=template&id=13f5485a&scoped=true&"
import script from "./Strech.vue?vue&type=script&lang=ts&"
export * from "./Strech.vue?vue&type=script&lang=ts&"
import style0 from "./Strech.vue?vue&type=style&index=0&id=13f5485a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f5485a",
  null
  
)

export default component.exports